import styled from 'styled-components';

export const Copy = styled.p`
    font-size: 20px;
    line-height: 32px;
    max-width: 500px;
    margin: 0 auto;
    margin-bottom: 30px;
`